export class AccessControlBookColumnsDto {
    routeKey = false;
    address = false;
    transfer = false;
    transport = false;
    delivery = false;
    trademarkShipper = false;
    trademarkTarget = false;
    client = false;
    plateA = false;
    plateB = false;
    cTrans = false;
    typology = false;
    parkingEntryMomentDate = false;
    parkingEntryMomentHour = false;
    parkingExitMomentDate = false;
    parkingExitMomentHour = false;
    entryMomentDate = false;
    entryMomentHour = false;
    exitMomentDate = false;
    exitMomentHour = false;
    parkingTotalTime = false;
    dockTotalTime = false;
    totalTime = false;
    entryUserAlias = false;
    exitUserAlias = false;
    slotDate = false;
    slotStartHour = false;
    slotEndHour = false;
    slotDuration = false;
    slotWaitingTime = false;
    slotDelayTime = false;
    slotType = false;
    userTags = false;
    assignedKey = false;
    entryMoment = false;
    exitMoment = false;
    gateName = false;
    dock = false;
    intervalSlot = false;
    weight = false;
    gateEntryMomentDate = false;
    gateEntryMomentHour = false;
    gateExitMomentDate = false;
    gateExitMomentHour = false;
    gateTotalTime = false;
    dockEntryMomentDate = false;
    dockEntryMomentHour = false;
    dockExitMomentDate = false;
    dockExitMomentHour = false;
    columns: string[]

    setColumnValue(columnName: string, value: boolean): void {
        const normalizedKey = this.normalizeColumnName(columnName);
        if (normalizedKey && normalizedKey in this) {
            // @ts-ignore
            this[normalizedKey] = value;
        }
    }

    normalizeColumnName(columnName: string): keyof AccessControlBookColumnsDto | null {
        const map: Record<string, keyof AccessControlBookColumnsDto> = {
            routekey: "routeKey",
            address: "address",
            transfer: "transfer",
            transport: "transport",
            delivery: "delivery",
            trademarkshipper: "trademarkShipper",
            trademarktarget: "trademarkTarget",
            client: "client",
            platea: "plateA",
            plateb: "plateB",
            ctrans: "cTrans",
            typology: "typology",
            parkingentrymomentdate: "parkingEntryMomentDate",
            parkingentrymomenthour: "parkingEntryMomentHour",
            parkingexitmomentdate: "parkingExitMomentDate",
            parkingexitmomenthour: "parkingExitMomentHour",
            entrymomentdate: "entryMomentDate",
            entrymomenthour: "entryMomentHour",
            exitmomentdate: "exitMomentDate",
            exitmomenthour: "exitMomentHour",
            parkingtotaltime: "parkingTotalTime",
            docktotaltime: "dockTotalTime",
            totaltime: "totalTime",
            entryuseralias: "entryUserAlias",
            exituseralias: "exitUserAlias",
            slotdate: "slotDate",
            slotstarthour: "slotStartHour",
            slotendhour: "slotEndHour",
            slotduration: "slotDuration",
            slotwaitingtime: "slotWaitingTime",
            slotdelaytime: "slotDelayTime",
            slottype: "slotType",
            usertags: "userTags",
            assignedkey: "assignedKey",
            entrymoment: "entryMoment",
            exitmoment: "exitMoment",
            gatename: "gateName",
            dock: "dock",
            intervalslot: "intervalSlot",
            weight: "weight",
            gateentrymomentdate: "gateEntryMomentDate",
            gateentrymomenthour: "gateEntryMomentHour",
            gateexitmomentdate: "gateExitMomentDate",
            gateexitmomenthour: "gateExitMomentHour",
            gatetotaltime: "gateTotalTime",
            dockentrymomentdate: "dockEntryMomentDate",
            dockentrymomenthour: "dockEntryMomentHour",
            dockexitmomentdate: "dockExitMomentDate",
            dockexitmomenthour: "dockExitMomentHour",
        };

        const key = columnName.toLowerCase();
        return map[key] || null;
    }
}
